import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { CORNERDESIGN_VALUES, WashBasinDefaultModel, WashBasinModel, LEFT_RIGHT } from 'franke-trough-dependencies';

import { GlobalPrivateState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

import { ElementPosition, ElementPositionState } from '../Utils';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './BasinDimensions.messages';
import { WarningsTooltip } from '../../Warnings';
import { isConfigurationEditable } from 'src/redux/utils.redux';
import ConsolesOverlapChoice from '../Assemblies/ConsoleOverlapChoice';

export interface CornerDesignProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  validatedConfiguration: GlobalPrivateState['validatedConfiguration'];
  warning: GlobalPrivateState['warning'];
}

export interface CornerDesignState {
  cornerDesign?: WashBasinModel['cornerDesign'];
  cornerDesignPosition: WashBasinModel['cornerDesignPosition'];
}

interface CornerDesignDispatchProps {
  cornerDesign?: WashBasinModel['cornerDesign'];
  cornerDesignPosition?: WashBasinModel['cornerDesignPosition'];
}

const CornerDesignLabel: React.SFC<{value: CORNERDESIGN_VALUES}> = (props) => {
  switch (props.value) {
    case 'none':
      return (<span><FormattedMessage {...MESSAGES.cornerDesignLabelWithout} /></span>);
    case 'radius':
      return (<span><FormattedMessage {...MESSAGES.cornerDesignLabelRadius} /></span>);
    case 'bevel':
      return (<span><FormattedMessage {...MESSAGES.cornerDesignLabelBevel} /></span>);
    default:
      return null;
  }
};

export class CornerDesignPartial extends React.Component<CornerDesignProps> {

  constructor(props: CornerDesignProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleCornerDesign = this.handleCornerDesign.bind(this);
  }

  public render() {
    const {
      warning,
    } = this.props;

    return (
      <div className="partial-corner-design position-relative pb-3">
        {this.washBasin && this.washBasin.typeOfInstallation && this.washBasin.typeOfInstallation === 'with' ? (
          <div className="row">
            <div className="col-12">
              <p>
                <small>
                  <FormattedMessage {...MESSAGES.cornerDesignNotSelectAble} />
                </small>
              </p>
            </div>
          </div>
        ) : (
          <>
            {this.defaults && this.defaults.cornerDesign && this.defaults.cornerDesign.values && this.defaults.cornerDesign.values.map((value, index) => {
              const key = `item_corner_design_${index}`;
              const disabled = warning.requireReset.cornerDesign.required || !isConfigurationEditable();

              return (
                <div key={key} className="col-12 mb-2">
                  {index === 0 && isConfigurationEditable() && (
                    <WarningsTooltip itemKey="cornerDesign" />
                  )}
                  {index === 0 && (
                    <ConsolesOverlapChoice id="cornerDesignOverlap" />
                  )}
                  <label className={classNames({
                    'disabled': disabled
                  })}>
                    <CornerDesignLabel value={value} />
                    <input
                      type="radio" name="cornerDesign" value={value}
                      checked={this.selectedValue === value} onChange={this.handleChange}
                      disabled={disabled}
                    />
                    <span className="checkmark"><></></span>
                  </label>
                  {(
                    this.selectedValue === 'radius' && value === 'radius' || 
                    this.selectedValue === 'bevel' && value === 'bevel'
                  ) && this.defaults && this.washBasin && (
                    <ElementPosition 
                      defaults={this.defaults.cornerDesignPosition}
                      onChange={(pos) => this.handleCornerDesign(pos)}
                      selected={this.washBasin.cornerDesignPosition || []}
                      disabled={disabled}
                    />
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    const cornerDesign = target.value as CORNERDESIGN_VALUES;

    this.dispatchWashBasinDimension({
      cornerDesign,
      cornerDesignPosition: null,
    });
  }

  private handleCornerDesign(selected: ElementPositionState['selected']) {
    if (!this.washBasin) { return; }
    
    const cornerDesignPosition = (this.washBasin && this.washBasin.cornerDesignPosition) || [];

    (Object.keys(selected) as (keyof ElementPositionState['selected'])[]).forEach((key: LEFT_RIGHT) => {
      const index = cornerDesignPosition.indexOf(key);
      const hasKey = index > -1 ? true : false;
      
      if (selected[key] === true && !hasKey) {
        cornerDesignPosition.push(key);
      }
      if (selected[key] === false && hasKey) {        
        cornerDesignPosition.splice(index);
      }
    });

    const positions = cornerDesignPosition && cornerDesignPosition.length === 0 ? null : cornerDesignPosition;

    this.dispatchWashBasinDimension({
      cornerDesign: this.washBasin && this.washBasin.cornerDesign,
      cornerDesignPosition: positions,
    });
  }

  private dispatchWashBasinDimension(dispatchProps: CornerDesignDispatchProps) {
    const { configuration } = this.props;
    if (!isConfigurationEditable()) { return; }

    const washBasinDimension = configuration && 
      configuration.result && 
      configuration.result.washBasinDimension;


    if (this.configurationId && washBasinDimension) {
      const addingCorner = washBasinDimension.cornerDesign !== dispatchProps.cornerDesign && dispatchProps.cornerDesign !== 'none';
      const adjustingSide = washBasinDimension.cornerDesign === dispatchProps.cornerDesign && JSON.stringify(washBasinDimension.cornerDesignPosition) !== JSON.stringify(dispatchProps.cornerDesignPosition);
			
      washBasinDimension.cornerDesign = dispatchProps.cornerDesign as CORNERDESIGN_VALUES;
      washBasinDimension.cornerDesignPosition = dispatchProps.cornerDesignPosition as WashBasinModel['cornerDesignPosition'] || null;

      console.log('addingCorner', addingCorner);
      if (addingCorner) {
        washBasinDimension.cornerDesignPosition = [];

        if (washBasinDimension.typeOfInstallation !== 'with') {
          if (washBasinDimension.typeOfInstallation !== 'left') {
            washBasinDimension.cornerDesignPosition.push('left');
          }
          if (washBasinDimension.typeOfInstallation !== 'right') {
            washBasinDimension.cornerDesignPosition.push('right');
          }
        }
      }

			const allNone = washBasinDimension.cornerDesignPosition === null && washBasinDimension.cornerDesign !== 'none';
			if (allNone) {
				washBasinDimension.cornerDesign = 'none';
			}

      this.props.dispatch(requestAPIActions.load(
        'configuration',
        { 
          url: `/Configurations/${this.configurationId}`,
          options: {
            method: 'PATCH',
            data: {
              washBasinDimension,
            }
          },
        },
        true
      ));
    }
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }

  private get washBasin(): WashBasinModel | undefined | null {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.washBasinDimension;
  }

  private get selectedValue(): CORNERDESIGN_VALUES | undefined | null {
    return this.washBasin && this.washBasin.cornerDesign;
  }

  private get defaults(): WashBasinDefaultModel | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.defaults &&
      configuration.result.defaults.washBasinDimension;
  }

}

export const CornerDesign = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  validatedConfiguration: state.validatedConfiguration,
  warning: state.warning,
}))(CornerDesignPartial);

export default CornerDesign;